import request from '@/utils/request'

const baseUrl = '/erp/warehouse'

export const listWarehouse = (enabledOnly = false) => request({
  url: baseUrl + '/list', method: 'get', params: { enabledOnly }
})
export const saveWarehouse = data => request({ url: baseUrl + '/save', method: 'post', data })
export const setWarehouseEnabled = (id, enabled) => request({
  url: baseUrl + '/status', method: 'post', data: { id, enabled }
})
